// extracted by mini-css-extract-plugin
module.exports = {"mainmiddle":"RightSidebarLayout_mainmiddle___b5ab"};